import React, { useState } from "react";
import "./CVSearchBar.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { FaSearch } from "react-icons/fa";
import { Checkbox } from "primereact/checkbox";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateCVs } from "Redux/Actions/cvsActions";

const CVSearchBar = (props) => {
  const [motsclés, setMotsclés] = useState("");
  const [experience, setExperience] = useState(null);
  const [nivEtudes, setNivEtudes] = useState(null);
  const [secteurFormation, setSecteurFormation] = useState(null);
  const [composante, setComposante] = useState(null);
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [certification, setCertification] = useState(false);

  const isSearchingCvs = () => {
    if (
      nom === "" &&
      prenom === "" &&
      motsclés === "" &&
      !certification &&
      (experience === null || experience.length === 0) &&
      (nivEtudes === null || nivEtudes.length === 0) &&
      (secteurFormation === null || secteurFormation.length === 0) &&
      (composante === null || composante.length === 0)
    )
      return false;
    else {
      return true;
    }
  };
  // récupération des données et ajout des paramètres dans l'url de recherche
  const handleSearch = () => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/resumes/cvteque`);

    //Gestion des strings nom, prenom et mots clés
    if (nom != "") url.searchParams.set("surname", nom);
    if (prenom != "") url.searchParams.set("firstname", prenom);
    if (motsclés != "") url.searchParams.set("keyword", motsclés);

    //Gestion du bolléen certification
    if (certification) url.searchParams.set("certified", certification);

    //Gestion des inputs de type Array[Object]
    if (experience != null) {
      experience.forEach((item) =>
        url.searchParams.append("seniority", item.id)
      );
    }
    if (
      nivEtudes > 0 &&
      nivEtudes < props.secondaryTables.levelOfEducationsData.length - 1
    ) {
      nivEtudes.forEach((item) =>
        url.searchParams.append("educations[]", item.id)
      );
    }
    if (secteurFormation != null) {
      secteurFormation.forEach((item) =>
        url.searchParams.append("domain", item.id)
      );
    }
    if (composante != null) {
      composante.forEach((item) =>
        url.searchParams.append("composante", item.id)
      );
    }
    props.setUrl(url);
    props.handleUpdateCVs({ isCVsSearch: isSearchingCvs() });
  };

  return (
    <div className="cv_search_bar">
      {/* <h2 className="cv_search_bar__title">Trouvez un étudiant</h2> */}
      <div className="cv_search_bar__container">
        <div className="cv_search_bar__container__top">
          <div className="cv_search_bar__container__top__boxes">
            <div className="cv_search_bar__container__top__boxes__box">
              <label>MOTS CLÉS</label>
              <span className="cv_p-input-icon-left">
                <InputText
                  value={motsclés}
                  onChange={(e) => setMotsclés(e.target.value)}
                  placeholder="Voir les champs"
                  className="box__input"
                />
              </span>
            </div>
            <Divider layout="vertical" />

            <div className="cv_search_bar__container__top__boxes__box">
              <label>NIVEAU D&apos;EXPÉRIENCE</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={experience}
                options={props.secondaryTables.levelOfExperiencesData}
                onChange={(e) => setExperience(e.value)}
                optionLabel="label"
                placeholder="Junior"
                className="box__input"
                maxSelectedLabels={3}
                selectedItemsLabel={`${experience?.length} options sélectionnées`}
              />
            </div>
            <Divider layout="vertical" />

            <div className="cv_search_bar__container__top__boxes__box">
              <label>NIVEAUX D&apos;ÉTUDES</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={nivEtudes}
                options={props.secondaryTables.levelOfEducationsData.filter(
                  (level) => level.label !== "Indifférent"
                )}
                onChange={(e) => setNivEtudes(e.value)}
                optionLabel="label"
                placeholder="Bac"
                className="box__input"
                maxSelectedLabels={3}
                selectedItemsLabel={`${nivEtudes?.length} options sélectionnées`}
              />
            </div>
            <Divider layout="vertical" />

            <div className="cv_search_bar__container__top__boxes__box">
              <label>SECTEUR DE FORMATION</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={secteurFormation}
                options={props.secondaryTables.domainsData}
                onChange={(e) => setSecteurFormation(e.value)}
                optionLabel="label"
                placeholder="Informatique"
                className="box__input"
                maxSelectedLabels={0}
                selectedItemsLabel={`${secteurFormation?.length} options sélectionnées`}
              />
            </div>
          </div>
          <div
            className="cv_search_bar__container__top__inputSearch"
            onClick={() => handleSearch()}
          >
            <FaSearch />
          </div>
        </div>

        <div className="cv_search_bar__container__bottom">
          <div className="cv_search_bar__container__bottom__boxes__multiselect">
            <MultiSelect
              appendTo={document.getElementById("app")}
              value={composante}
              options={props.secondaryTables.educationComposanteData}
              onChange={(e) => setComposante(e.value)}
              optionLabel="label"
              placeholder="Composante"
              maxSelectedLabels={1}
              selectedItemsLabel={`${composante?.length} options sélectionnées`}
              className="box__input"
            />
          </div>
          <div className="cv_search_bar__container__bottom__boxes__box">
            <label>Prénom:</label>
            <InputText
              value={prenom}
              onChange={(e) => setPrenom(e.target.value)}
              placeholder="Alex, Emma"
              className="box__input"
            />
          </div>
          <div className="cv_search_bar__container__bottom__boxes__box">
            <label>Nom:</label>
            <InputText
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Lebon, Dupont"
              className="box__input"
            />
          </div>
          <div className="cv_search_bar__container__bottom__boxes__checkbox">
            <Checkbox
              id="cb1"
              onChange={(e) => setCertification(e.checked)}
              checked={certification}
            ></Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Certification diplôme
            </label>
            <p htmlFor="cb1" className="p-checkbox-label">
              Certification diplôme
            </p>
          </div>
          {props.cvs.isCVsSearch && (
            <li className="search_bar_refresh search_bar_refresh__cvs">
              <i
                className="pi pi-refresh"
                style={{ fontSize: "1.5rem", fontWeight: "600" }}
                onClick={() => {
                  setMotsclés("");
                  setExperience(null);
                  setNivEtudes(null);
                  setSecteurFormation(null);
                  setComposante(null);
                  setPrenom("");
                  setNom("");
                  setCertification(false);
                  let url = new URL(
                    `${process.env.REACT_APP_BASE_URL_API}/resumes/cvteque`
                  );
                  props.setUrl(url);
                  props.handleUpdateCVs({ isCVsSearch: false });
                }}
              />
            </li>
          )}
          <div
            className="cv_search_bar__container__bottom__inputSearch"
            onClick={() => handleSearch()}
          >
            <FaSearch />
          </div>
        </div>
      </div>
    </div>
  );
};

CVSearchBar.propTypes = {
  id: PropTypes.string,
  setFilteredCVs: PropTypes.func,
  handleUpdateCVs: PropTypes.func,
  cvs: PropTypes.object,
  auth: PropTypes.object,
  secondaryTables: PropTypes.object,
  setUrl: PropTypes.func,
};

const mapStateToProps = (state) => ({
  cvs: state.cvs,
  secondaryTables: state.secondaryTables,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateCVs: (value) => {
    dispatch(updateCVs(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVSearchBar);
